export class ContractLotDigital {
   id: string;
   serviceTypeId: number;
   enterpriseSign: any[];
   userSign: any[];
   importFileBase64: string;
   importFileName: string;
   code: string;
   contentDetails: string;
  maxPartnerNumber: number;
  contractSharePartners: any[];
  importFields: { idFileContract: string; fileName: string }[];
  serviceType?: any;
  serviceTypeName?: string;
  employmentContractTerm?: string;
  maxNumberOfCustomerInFlow?: number;
  contractDetails?: any;
  uploadedFiles?: any[];
  pdfFileList?: any[];
  pdfFiles?: any[];
  contractFiles?: any[];
  fileDetails?: any[];
  status?: any;

   public static build(): ContractLotDigital {
      const contractLot: ContractLotDigital = new ContractLotDigital();
      contractLot.id = null;
      contractLot.serviceTypeId = null;
      contractLot.userSign = null;
      contractLot.enterpriseSign = null;
      contractLot.importFileName = null;
      contractLot.importFileBase64 = null;
      contractLot.maxPartnerNumber = 1;
      return contractLot;
   }
}
